//全局常量

export const SHOW_MODAL = 'SHOW_MODAL'; //展示弹窗
export const HIDE_MODAL = 'HIDE_MODAL'; //关闭弹窗





